import { render } from "./EventPrc6.vue?vue&type=template&id=1507455d"
import script from "./EventPrc6.vue?vue&type=script&lang=js"
export * from "./EventPrc6.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__